import React, { useEffect, useState } from 'react'
import ReactApexChart from "react-apexcharts";

function Marketpair({data}) {

    const [chartData, setChartData] = useState({
        series: [44, 55, 41, 17, 15,18, 21, 88],
        options: {
            chart: {
                type: "donut",
            },
            labels: ["BTC/USDT", "BTC/FDUSD", "ETH/USDT", "ETH/FDUSD", "USDC/USDT","XRP/USDT","FDUSD/USDT","Others"],
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: "100%",
                        },
                        legend: {
                            position: "bottom",
                        },
                    },
                },
            ],
        },
    });

    useEffect(()=>{
     if(data){
        setChartData({...chartData,["series"] : Object.values(data),["options"] : { ...chartData?.options,["labels"] : Object.keys(data) }})
     }
    },[data])

    return (

        <div>
            <div id="chart">
                <ReactApexChart
                    options={chartData.options}
                    series={chartData.series}
                    type="donut"
                    height={350}
                />
            </div>
            <div id="html-dist"></div>
        </div>

    )
}

export default Marketpair;